var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.797,
    height: 20.798,
    viewBox: "0 0 20.797 20.798",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398",
    transform: "translate(-31.004 -54.504)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 26.542,
    height: 2.869,
    transform: "translate(51.801 56.533) rotate(135)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 26.542,
    height: 2.869,
    transform: "translate(33.033 54.504) rotate(45)",
    fill: "#3e3e3e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCross);
export default __webpack_public_path__ + "static/media/menu-cross.e73022549ea1ef099fb29b24c0473d19.svg";
export { ForwardRef as ReactComponent };